
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { getMonthName } from '@/utils/timeline.utils';

@Options({})
export default class TimelineMonth extends Vue {
  @Prop({ required: true })
  month!: Date;

  @Prop({ required: true })
  quarterColor!: string;

  @Prop({ default: false })
  isQuarterStart!: boolean;

  @Prop({ default: false })
  isQuarterEnd!: boolean;

  @Prop({ default: false })
  isSelected!: boolean;

  @Prop({ required: true })
  onMonthClick!: (month: Date) => void;

  get monthName(): string {
    return getMonthName(this.month, true);
  }

  handleClick(): void {
    this.onMonthClick(this.month);
  }
}
